import { z } from 'zod'

/**
 * Compact name index of nearby entities for on-device composer recognition.
 * Draft text is matched locally against these titles and never sent anywhere.
 */
export const entityIndexItemSchema = z.object({
  id: z.string().uuid(),
  kind: z.enum(['event', 'listing']),
  title: z.string(),
  startTime: z.string().nullable(),
  endTime: z.string().nullable(),
  locationName: z.string().nullable(),
  coverImageUrl: z.string().nullable(),
})

export type EntityIndexItem = z.infer<typeof entityIndexItemSchema>

export const entityIndexQuerySchema = z.object({
  lat: z.coerce.number().min(-90).max(90).optional(),
  lng: z.coerce.number().min(-180).max(180).optional(),
})

export type EntityIndexQuery = z.infer<typeof entityIndexQuerySchema>

export const entityIndexResponseSchema = z.object({
  items: z.array(entityIndexItemSchema),
})

export type EntityIndexResponse = z.infer<typeof entityIndexResponseSchema>
